<template>
  <div class="space">
    空格占位，渲染时不显示
  </div>
</template>

<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseSpace',
  mixins: [ baseComponentMixins ],
}
</script>
<style lang="scss" scoped>
.space{
  border: 1px dashed #17b3a3;
  text-align: center;
  min-height: 58px;
  line-height: 34px;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  &:hover{
    background: #f6f7ff;
  }
}
</style>